import React from "react"
import "./Pdp-Colours.css"

const PdpColors = props => (
  <div>
    <input
      id={"radio-" + props.radionumber}
      className="radio-colour"
      name="radio-group"
      type="radio"
      checked
    />
    <label
      for={"radio-" + props.radionumber}
      className={"radio-colour-label" + " " + "pdp-" + props.colour}
    />
  </div>
)

export default PdpColors
